import script from "./ExpiryDatesScanView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpiryDatesScanView.vue?vue&type=script&setup=true&lang=ts"

import "./ExpiryDatesScanView.vue?vue&type=style&index=0&id=48bdac58&scoped=true&lang=css"

import exportComponent from "D:\\Github\\SmsAdminOnlineApplication\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48bdac58"]])

export default __exports__